import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
  Tooltip,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";
import Loader from "components/loader/Loader";
import { Link } from "react-router-dom";

import tutorsModal from "models/tutors.modal";
import enquiriesModal from "models/enquiries.modal";
import "../style.css";
import moment from "moment";
import EnquiryModal from "../../../models/enquiries.modal";

const Enquiry = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [modal1, setModal1] = useState(false);

  const toggleModal = () => {
    setModal1(!modal1);
  };
  const [modal2, setModal2] = useState(false);

  const toggleModal1 = () => {
    setModal2(!modal2);
  };
  const [modal3, setModal3] = useState(false);

  const toggleModal2 = () => {
    setModal3(!modal3);
  };
  const [modal4, setModal4] = useState(false);

  const toggleModal4 = () => {
    setModal4(!modal4);
  };

  const [modal5, setModal5] = useState(false);

  const toggleModal5 = () => {
    setModal5(!modal5);
  };
  const [totalpage, setTotalpage] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
   const parameters = {};
   for (let [key, value] of searchParams) {
    parameters[key] = value;
  }
  
  const getListData = async () => {
    setIsLoading(true);
    
    // Dummy data for new enquiries
    const dummyEnquiryData = {
      data: [
        {
          _id: "1",
          id: "1",
          status: "new_enq",
          Created_ON: "2024-01-15T10:30:00Z",
          studentApi_parent: {
            auth_user: {
              first_name: "Rajesh",
              last_name: "Kumar",
              username: "9876543210"
            },
            modeOfTution: "Online"
          },
          students: [
            { id: "1", name: "Arjun Kumar", class: "10" },
            { id: "2", name: "Priya Kumar", class: "8" }
          ]
        },
        {
          _id: "2",
          id: "2",
          status: "new_enq",
          Created_ON: "2024-01-16T14:20:00Z",
          studentApi_parent: {
            auth_user: {
              first_name: "Sunita",
              last_name: "Sharma",
              username: "9876543211"
            },
            modeOfTution: "Offline"
          },
          students: [
            { id: "3", name: "Vikash Sharma", class: "12" }
          ]
        },
        {
          _id: "3",
          id: "3",
          status: "new_enq",
          Created_ON: "2024-01-17T09:15:00Z",
          studentApi_parent: {
            auth_user: {
              first_name: "Amit",
              last_name: "Verma",
              username: "9876543212"
            },
            modeOfTution: "Hybrid"
          },
          students: [
            { id: "4", name: "Sneha Verma", class: "11" },
            { id: "5", name: "Rohit Verma", class: "9" },
            { id: "6", name: "Kavya Verma", class: "7" }
          ]
        },
        {
          _id: "4",
          id: "4",
          status: "new_enq",
          Created_ON: "2024-01-18T16:45:00Z",
          studentApi_parent: {
            auth_user: {
              first_name: "Meera",
              last_name: "Patel",
              username: "9876543213"
            },
            modeOfTution: "Online"
          },
          students: [
            { id: "7", name: "Karan Patel", class: "6" }
          ]
        },
        {
          _id: "5",
          id: "5",
          status: "new_enq",
          Created_ON: "2024-01-19T11:30:00Z",
          studentApi_parent: {
            auth_user: {
              first_name: "Deepak",
              last_name: "Singh",
              username: "9876543214"
            },
            modeOfTution: "Offline"
          },
          students: [
            { id: "8", name: "Anita Singh", class: "10" },
            { id: "9", name: "Ravi Singh", class: "12" }
          ]
        },
        {
          _id: "6",
          id: "6",
          status: "new_enq",
          Created_ON: "2024-01-20T13:25:00Z",
          studentApi_parent: {
            auth_user: {
              first_name: "Pooja",
              last_name: "Gupta",
              username: "9876543215"
            },
            modeOfTution: "Online"
          },
          students: [
            { id: "10", name: "Manish Gupta", class: "9" }
          ]
        }
      ],
      meta: {
        current_page: 1,
        per_page: 10,
        total_page: 1,
        total: 6
      }
    };
    
    setTimeout(() => {
      setIsLoading(false);
      setDataList(dummyEnquiryData);
      setTotalpage(dummyEnquiryData.meta.total_page);
      setCurrentPage(dummyEnquiryData.meta.current_page);
      setPerPage(dummyEnquiryData.meta.per_page);
    }, 1000);
  };

  useEffect(() => {
    getListData();
  }, [location]);

  useEffect(() => {
    getListData();
  }, [currentPage]);
  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Message", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          contact_usModel.delete(delId).then((res) => {
            helper.sweetalert.toast(res.data?.message);
            getListData();
          });
        }
      });
  };
  const [selectedClassType, setSelectedClassType] = useState("");

  const handleChangeClassType = (event) => {
    // Get the selected option
    const selectedOption = event.target.options[event.target.selectedIndex];
    // Update the state variables with the ID and name
    setSelectedClassType(selectedOption.value);
  };

  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [formattedDateTime, setFormattedDateTime] = useState("");

  const handleDateChange = (e) => {
    setDate(e.target.value);
    formatDateTime(e.target.value, time);
  };

  const handleTimeChange = (e) => {
    setTime(e.target.value);
    formatDateTime(date, e.target.value);
  };

  const formatDateTime = (date, time) => {
    if (date && time) {
      const dateTime = moment(`${date}T${time}`);
      setFormattedDateTime(dateTime.format("MM/DD/YYYY hh:mm A"));
    }
  };

  const combinedatetime = `${date}T${time}`;

  const [enquriId, setEnquriId] = useState();

  const [enquriStatus, setEnquriStatus] = useState();

  //for pending new enqury(firdosh)
  const EnquriesStatusChange = (event) => {
    event.preventDefault();
    
    // Simulate status change to pending
    setTimeout(() => {
      setDataList(prevData => ({
        ...prevData,
        data: prevData.data.map(item => 
          item.id === enquriId 
            ? { ...item, status: "pending_enq" }
            : item
        )
      }));
      helper.sweetalert.toast("Enquiry status changed to pending", "success");
      setModal2(false);
    }, 500);
  };

  //for Disqualify new enqury(firdosh)
  const Disqualify = (event) => {
    event.preventDefault();
    
    // Simulate disqualifying enquiry
    setTimeout(() => {
      setDataList(prevData => ({
        ...prevData,
        data: prevData.data.filter(item => item.id !== enquriId)
      }));
      helper.sweetalert.toast("Enquiry disqualified successfully", "success");
      setModal3(false);
    }, 500);
  };
  // add enquriy
  const Addenquries = async () => {};
  const filteredData = dataList?.data?.filter((item) => {
    const fullName = `${item?.studentApi_parent?.auth_user?.first_name} ${item?.studentApi_parent?.auth_user?.last_name}`.toLowerCase();
    const username = item?.studentApi_parent?.auth_user?.username?.toLowerCase();
    const modeOfTution = item?.studentApi_parent?.modeOfTution?.toLowerCase();
    const studentsCount = item?.students?.length || 0;
  
    // Check if the searchQuery matches fullName, username, modeOfTution or studentsCount
    const matchesSearch = searchQuery.toLowerCase();
    return (
      fullName.includes(matchesSearch) ||
      username.includes(matchesSearch) ||
      modeOfTution.includes(matchesSearch) ||
      studentsCount === Number(matchesSearch)
    );
  });
  return (
    <>
      <Container className="pt-7">
       
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between ">
                  <h3 className="mb-0">New Enquiry</h3>
                  <div className="d-flex flex-row">
                    {/* 
                  <Button
                    size="sm"
                    //  to="/admin/academic/addacademic/"
                    //  tag={Link}
                    onClick={toggleModal4}
                    style={{
                      backgroundColor: "#080278",
                      color: "white",
                      width: "100%",
                    }}
                  >
                    Add New Enquiry
                  </Button>*/}
                    <Input
                      className="mr-4"
                      type="text"
                      placeholder="Search"
                      size="sm"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)} // Update the state on input change
                    />
                  </div>
                </CardHeader>
                 {isLoading ? (
                                  <div>
                                    <div  className="text-center align-middle py-4">
                                      Please wait...
                                      <Loader />
                                    </div>
                                  </div>
                                ) :(
                                <>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">S.No.</th>
                      <th scope="col">Guardian Name (Mobile No)</th>
                      <th scope="col">Mode of Tuition</th>
                      <th scope="col">Status</th>
                      <th scope="col">No of Students</th>
                      <th scope="col"> Date & Time of Enquiry</th>

                      <th scope="col">Action</th>
                    </tr>
                  </thead>

                  {!isLoading && (
                    <tbody>
                    {dataList?.data?.length > 0 ? (
                      dataList.data
                        .filter((item) => {
                          // Replace this with your filtering logic
                          const fullName = `${item?.studentApi_parent?.auth_user?.first_name} ${item?.studentApi_parent?.auth_user?.last_name}`.toLowerCase();
                          const username = item?.studentApi_parent?.auth_user?.username.toLowerCase();
                          return (
                            fullName.includes(searchQuery.toLowerCase()) ||
                            username.includes(searchQuery.toLowerCase())
                          );
                        })
                        .map((item, index) => {
                          const date = new Date(item?.Created_ON);
                          const day = String(date.getDate()).padStart(2, "0");
                          const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
                          const year = date.getFullYear();
                          let hours = date.getHours();
                          const minutes = String(date.getMinutes()).padStart(2, "0");
                          const ampm = hours >= 12 ? "pm" : "am";
                          hours = hours % 12 || 12; // Convert to 12-hour format and handle midnight (0 hours)
                          const formattedTime = `${hours}:${minutes}${ampm}`;
                          const formattedDate = `${day}/${month}/${year}`;
                          const finalDate = `${formattedDate} ${formattedTime}`;
              
                          return (
                            <tr key={item._id} style={{ cursor: "pointer" }}>
                              <td id="tabledata">
                                {(currentPage - 1) * perPage + index + 1}
                              </td>
                              <td className="p-0 pl-3" id="tabledata">
                                {item?.studentApi_parent?.auth_user?.first_name}{" "}
                                {item?.studentApi_parent?.auth_user?.last_name}
                                <span style={{ marginLeft: "5px", cursor: "pointer" }}>
                                  {item?.studentApi_parent?.auth_user?.username}
                                  <span style={{ marginLeft: "3px" }}>
                                    <i className="fa-solid fa-phone"></i>
                                  </span>
                                </span>
                              </td>
                              <td>{item?.studentApi_parent?.modeOfTution || "-"}</td>
                              <td className="p-0" id="tabledata">
                                <span
                                  style={{
                                    backgroundColor: "blue",
                                    color: "white",
                                    padding: "5px",
                                    borderRadius: "5px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {item?.status}
                                </span>
                              </td>
                              <td id="tabledata">
                                <span
                                  style={{
                                    backgroundColor: "blue",
                                    color: "white",
                                    padding: "7px",
                                    borderRadius: "5px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {item?.students?.length}
                                </span>
                              </td>
                              <td>{finalDate || "-"}</td>
              
                              <td
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  fontSize: "16px",
                                }}
                                className="p-0 pt-2"
                              >
                                {/* Tooltip and action buttons */}
                                <UncontrolledTooltip placement="top" target="eyeTooltip">
                                  View
                                </UncontrolledTooltip>
                                <Link
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "blue",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    borderRadius: "30%",
                                    cursor: "pointer",
                                  }}
                                  id="eyeTooltip"
                                  to={`/admin/viewenquiry/${item?.studentApi_parent?.auth_user?.username}/${item?.id}`}
                                >
                                  <i className="fa-solid fa-eye"></i>
                                </Link>
              
                                <UncontrolledTooltip placement="top" target="checkTooltip">
                                  Qualified
                                </UncontrolledTooltip>
                                <Link
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "green",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    borderRadius: "30%",
                                    cursor: "pointer",
                                  }}
                                  id="checkTooltip"
                                  to={`/admin/qualifiedenquiriesViewpage/${item.id}`}
                                >
                                  <i className="fa-solid fa-check"></i>
                                </Link>
              
                                <UncontrolledTooltip placement="top" target="clockTooltip">
                                  Pending
                                </UncontrolledTooltip>
                                <p
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "orange",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    borderRadius: "30%",
                                    cursor: "pointer",
                                  }}
                                  id="clockTooltip"
                                  onClick={() => {
                                    toggleModal1();
                                    setEnquriId(item.id);
                                    setEnquriStatus("Pending Enquiry");
                                  }}
                                >
                                  <i className="fa-solid fa-clock-rotate-left"></i>
                                </p>
              
                                <UncontrolledTooltip placement="top" target="userTooltip">
                                  Disqualified
                                </UncontrolledTooltip>
                                <p
                                  style={{
                                    margin: "0 5px",
                                    fontSize: "15px",
                                    color: "red",
                                    alignItems: "center",
                                    display: "inline-block",
                                    marginTop: "10px",
                                    borderRadius: "30%",
                                    cursor: "pointer",
                                  }}
                                  id="userTooltip"
                                  onClick={() => {
                                    toggleModal2();
                                    setEnquriId(item?.id);
                                    setEnquriStatus("Disqualified Enquiry");
                                  }}
                                >
                                  <i className="fa-solid fa-user-xmark"></i>
                                </p>
                              </td>
                            </tr>
                          );
                        })
                    ) : (
                      <tr style={{ textAlign: "center" }}>
                        <td colSpan="6" style={{ verticalAlign: "middle" }}>
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                  )}
                </Table>
                <CardFooter className="py-4">
                  <TablePagination
                     totalPages={totalpage}
                     currentPage={currentPage}
                    pageUrl="/admin/newenquiries?"
                  />
                </CardFooter></> )}
              </Card>
            </div>
          </Row>
       

        <Modal isOpen={modal1} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>
            <h4> Assign Tutors</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Select Tutors</Label>
                  <Input
                    id="forType"
                    type="select"
                    // onChange={(e) => {
                    //   interViewUser(e.target.value, "board");
                    // }}
                  >
                    <option value="">select Option</option>
                    {/* {dataList &&
                      dataList?.map((item, index) => {
                        return (
                          <option value={item.mobile}>
                            {item.user?.first_name} ({item?.mobile})
                          </option>
                        );
                      })} */}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{ float: "right", marginLeft: "5%" }}
                // onClick={}
              >
                Save
              </Button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal2} toggle={toggleModal1}>
          <ModalHeader toggle={toggleModal1}>
            <h4>Enquiry Pending </h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={EnquriesStatusChange}>
              <Input type="textarea" placeholder="Enter Reason" name="remark" />
              <Input
                type="date"
                className="mt-3"
                value={date}
                onChange={handleDateChange}
              />
              <Input
                type="time"
                className="mt-3"
                value={time}
                onChange={handleTimeChange}
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal1}>
                  Cancel
                </Button>
                {/* 
                        {addsLoadig ? (
                          <Loader color={"blue"} />
                        ) : ( */}
                <Button
                  color="primary"
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                  }}
                  onClick={toggleModal1}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal3} toggle={toggleModal2}>
          <ModalHeader toggle={toggleModal2}>
            <h4> Enquiry Disqualify</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={Disqualify}>
              <Input type="textarea" placeholder="Enter Reason" name="remark" />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal2}>
                  Cancel
                </Button>
                <Button
                  color="primary"
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                  }}
                  // onClick={}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal4} toggle={toggleModal4} size="lg">
          <ModalHeader toggle={toggleModal4}>
            <h4> Add Parent Details</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={Addenquries}>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Parent First Name </Label>
                    <Input type="text" placeholder="Enter First Name" />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Parent Last Name</Label>
                    <Input type="text" placeholder="Enter Last Name" />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Parent Name </Label>
                    <Input type="text" placeholder="Enter Parent Name" />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Mobile no</Label>
                    <Input type="text" placeholder="Enter Mobile no" />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Email Address</Label>
                    <Input type="text" placeholder="Enter Email Address" />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Mode of Tuition</Label>

                    <Input id="forType" name="forType" type="select">
                      <option value="">Select Mode </option>
                      <option value="online">online</option>
                      <option value="offline">offline</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Gender</Label>
                    <Input type="select" placeholder="Enter Gender">
                      <option> Male</option>
                      <option> Female</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Loaction</Label>
                    <Input type="text" placeholder="Enter Loaction" />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">State</Label>
                    <Input type="text" placeholder="Enter State" />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">City</Label>
                    <Input type="text" placeholder="Enter City" />
                  </FormGroup>
                </Col>
              </Row>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal4}>
                  Cancel
                </Button>
                {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                <Button
                  color="primary"
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                  }}
                  // onClick={}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal5} toggle={toggleModal5}>
          <ModalHeader toggle={toggleModal5}>
            <h4> Enquiry Qualify</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={EnquriesStatusChange}>
              <Row>
                <Col md={6}>
                  <Label>Type of Class</Label>
                  <Input id="forType" type="select" name="class_type">
                    <option value="">Select Class Type</option>
                    <option value="Separate Class">Separate Class</option>
                    <option value="Combined Class">Combined Class</option>
                    <option value=" SME"> SME</option>
                  </Input>
                </Col>
                <Col md={6}>
                  <Label>Assign to</Label>
                  <Input id="forType" type="select" name="assigned_to">
                    <option value="">Select Assign to</option>
                    <option value="Pawan">Pawan</option>
                    <option value="Amit">Amit</option>
                  </Input>
                </Col>
              </Row>
              <Row>
                <Col md={6} className="mt-3">
                  <Label>Remark/Feedback (Internal)</Label>
                  <Input
                    type="textarea"
                    placeholder="Enter Remark/Feedback"
                    name="remark"
                  />
                </Col>{" "}
                <Col md={6} className="mt-3">
                  <Label>Remark/Feedback (For tutor)</Label>
                  <Input
                    type="textarea"
                    placeholder="Enter Remark/Feedback"
                    name="tutor_remark"
                  />
                </Col>
              </Row>

              <div style={{ marginTop: "10px" }}>
                <Row>
                  <Col md={12} style={{ float: "right" }}>
                    <Button
                      type="submit"
                      style={{
                        backgroundColor: "green",
                        color: "white",
                        float: "right",
                      }}
                      // tag={Link}
                      // to={`/admin/qualifiedenquiriesviewpage`}
                      // onClick={toggleModal1}
                    >
                      Qualified
                    </Button>
                    {/* <Button
                        type="submit"
                        style={{
                          backgroundColor: "#fcb603",
                          color: "white",
                          float: "right",
                        }}
                        onClick={toggleModal1}
                      >
                        Pending
                      </Button>
                      <Button
                        type="submit"
                        // style={{ float: "right", marginTop: "20px" }}
                        onClick={toggleModal2}
                        style={{
                          backgroundColor: "#fc0f03",
                          color: "white",
                          float: "right",
                        }}
                      >
                        Disqualified
                      </Button> */}
                  </Col>
                </Row>
              </div>
            </Form>
          </ModalBody>
        </Modal>
      </Container>
    </>
  );
};

export default Enquiry;
